import { Graph } from '@antv/x6';
import { Themes } from '@maxtropy/components';

// 初始化画图
export function initMockScTopoGraph(dom: HTMLElement, theme: Themes): Graph {
  return new Graph({
    container: dom,
    panning: true,
    mousewheel: true,
    grid: {
      size: 4,
      visible: true,
      type: 'dot',
      args: {
        color: '#ffffff35', // 网点颜色
        thickness: 1, // 网点大小
      },
    },
    background: {
      color: theme === Themes.DARK ? 'var(--mx-module-bg-color)' : '#FAFAFA',
    },
    interacting: {
      nodeMovable: false,
    },
  });
}
